import React from "react";
import { useApp } from "../context/AppContext";

const FALLBACK = "/logo192.png";

const ArtistCard = ({ artist, isAr: isArProp }) => {
  const { t, lang } = useApp();
  const isAr  = isArProp ?? (lang === "ar");

  const name      = isAr ? (artist.name_ar      || artist.name)      : (artist.name      || "");
  const specialty = isAr ? (artist.specialty_ar  || artist.specialty) : (artist.specialty || "");
  const intro     = isAr ? (artist.intro_ar      || artist.intro)     : (artist.intro     || "");
  const works     = (artist.images || []).slice(0, 4);
  const id        = artist.id || artist._id;

  return (
    <article className="acard">
      <div className="acard-top">
        <img
          className="acard-avatar"
          src={artist.photo_url || artist.profileImage || FALLBACK}
          alt={name}
          onError={(e) => { e.currentTarget.src = FALLBACK; }}
        />
        <div className="acard-id">
          <h3>{name}</h3>
          {specialty && <div className="specialty">{specialty}</div>}
          {artist.country && (
            <div className="loc"><i className="fa-solid fa-location-dot" /> {artist.country}</div>
          )}
        </div>
      </div>

      {intro && <p className="acard-intro">{intro}</p>}

      {works.length > 0 && (
        <div className="acard-works">
          {works.map((src, i) => (
            <img key={i} src={src} alt={`${name} work ${i + 1}`}
              onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
          ))}
        </div>
      )}

      <div className="acard-foot">
        <div className="links">
          {artist.website   && <a href={artist.website}              target="_blank" rel="noreferrer" title="Website"><i className="fa-solid fa-globe"   /></a>}
          {artist.email     && <a href={`mailto:${artist.email}`}                                     title="Email"  ><i className="fa-solid fa-envelope" /></a>}
          {artist.telephone && <a href={`tel:${artist.telephone}`}                                    title="Phone"  ><i className="fa-solid fa-phone"    /></a>}
        </div>
        <a className="btn btn-outline" style={{ padding: "8px 18px", fontSize: "0.85rem" }} href={`/artists/${id}`}>
          {t("viewProfile")}
        </a>
      </div>
    </article>
  );
};

export default ArtistCard;
